/**
 * Recovery globale dei lock di interazione (freeze tap / #root pointer-events).
 * Il count dei Modal vive qui così App e Modal condividono la stessa fonte.
 */

let modalChromeLockCount = 0;

export const getModalChromeLockCount = () => modalChromeLockCount;

export const incrementModalChromeLock = () => {
  modalChromeLockCount += 1;
  return modalChromeLockCount;
};

/** Decrementa in modo safe. Ritorna il count dopo il decremento. */
export const decrementModalChromeLock = () => {
  modalChromeLockCount = Math.max(0, modalChromeLockCount - 1);
  return modalChromeLockCount;
};

export const resetModalChromeLockCount = () => {
  modalChromeLockCount = 0;
};

const restoreRootPointerEvents = () => {
  const root = document.getElementById('root');
  if (!root) return;
  root.style.pointerEvents = '';
  root.removeAttribute('aria-hidden');
};

const emitSchedulerGestureReset = () => {
  try {
    window.dispatchEvent(new CustomEvent('scheduler:reset-gestures'));
  } catch (_) {
    /* ignore */
  }
};

export const hasVisibleModal = () =>
  Boolean(document.querySelector('[data-modal-open="true"]'));

export const isInteractionBlocked = () => {
  const root = document.getElementById('root');
  const rootBlocked =
    Boolean(root) &&
    (root.style.pointerEvents === 'none' ||
      window.getComputedStyle(root).pointerEvents === 'none');
  const bodyLocked = document.body.style.overflow === 'hidden' && !hasVisibleModal();
  return rootBlocked || bodyLocked;
};

export const healInteractionState = ({ reason } = {}) => {
  resetModalChromeLockCount();
  restoreRootPointerEvents();
  document.body.style.overflow = '';
  emitSchedulerGestureReset();
  if (
    process.env.NODE_ENV === 'development' &&
    reason &&
    (reason === 'dev-watchdog' ||
      reason === 'modal-mismatch' ||
      reason.startsWith('route:') ||
      reason === 'visibilitychange' ||
      reason === 'pageshow')
  ) {
    // eslint-disable-next-line no-console
    console.warn('[interactionRecovery] heal', reason);
  }
};
